import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import type { InvoicingPlanListStore } from "@src/components/modules/invoicing-plan/List/store";
import { Select } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";

type BasicExportModalProps = {
  readonly store: InvoicingPlanListStore;
};

export const BasicExportModal = observer(function BasicExportModal({
  store,
}: BasicExportModalProps) {
  return (
    <Modal
      isCentered
      isOpen={store.basicExportModalDisclosure.isOpen}
      onClose={store.basicExportModalDisclosure.onClose}
      trapFocus={false}
    >
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          <Trans>Export Billing Plan</Trans>
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <VStack align="stretch" spacing="4">
            <Select
              label={t`Month`}
              placeholder={t`Select month`}
              options={store.monthOptions}
              value={store.exportMonth.toString()}
              onChange={store.setExportMonth}
            />

            <Select
              label={t`Year`}
              placeholder={t`Select year`}
              options={store.yearOptions}
              value={store.exportYear.toString()}
              onChange={store.setExportYear}
            />
          </VStack>
        </ModalBody>

        <ModalFooter>
          <HStack spacing="2">
            <Button
              onClick={store.basicExportModalDisclosure.onClose}
              variant="outline"
            >
              <Trans>Cancel</Trans>
            </Button>

            <Button
              colorScheme="violet"
              isLoading={store.isExportBasicLoading}
              onClick={store.handleExportBasic}
            >
              <Trans>Export</Trans>
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
});
